import { Phone } from "@phosphor-icons/react";
import { useLocation } from "react-router-dom";
import { Logo } from "./Logo";

const LINKS = [
  { hash: "#how-it-works", label: "How it works", id: "nav-link-how-it-works" },
  { hash: "#pricing", label: "Pricing", id: "nav-link-pricing" },
  { hash: "#faq", label: "FAQ", id: "nav-link-faq" },
];

export const Header = () => {
  const { pathname } = useLocation();
  const base = pathname === "/" ? "" : "/";

  return (
    <header className="sticky top-0 z-50 border-b-2 border-line bg-asphalt">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:h-20 sm:px-6">
        <a href={`${base}#top`} data-testid="header-logo-link" className="flex min-h-[44px] items-center gap-3">
          <Logo className="h-9 w-9 sm:h-10 sm:w-10" />
          <span className="leading-none">
            <span className="block font-display text-lg font-bold uppercase tracking-tight sm:text-xl">
              Niagara <span className="text-safety">Callback</span>
            </span>
            <span className="mt-1 hidden font-mono text-[10px] uppercase tracking-[0.2em] text-smoke sm:block">
              Niagara Region &amp; Hamilton
            </span>
          </span>
        </a>
        <nav className="hidden items-center gap-6 md:flex" aria-label="Main">
          {LINKS.map((l) => (
            <a
              key={l.hash}
              href={`${base}${l.hash}`}
              data-testid={l.id}
              className="flex min-h-[44px] items-center font-mono text-xs uppercase tracking-[0.2em] text-smoke transition-colors duration-200 hover:text-safety"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="tel:+19053517489"
          data-testid="header-call-button"
          className="flex min-h-[48px] items-center gap-2 bg-safety px-4 font-display text-sm font-bold uppercase tracking-wide text-asphalt transition-[background-color,transform] duration-200 hover:bg-safetydeep active:translate-y-0.5 sm:min-h-[52px] sm:px-6 sm:text-base"
        >
          <Phone weight="bold" className="h-5 w-5" aria-hidden="true" />
          <span className="hidden sm:inline">905-351-7489</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </header>
  );
};
